module.exports = __webpack_public_path__ + "img/teacher-sample-4-vi-VN.882989f3.png";